export default "__VITE_ASSET__dVAS$Rj3__"